import { Link } from "react-router-dom";
import { SiteFooter as Footer } from "@jkast90/kast-common/ui";
import styles from "./SiteFooter.module.css";

const ORIGINAL_SITE_URL = "https://hashersnottrashers.org/";

/** The shared footer in HNT's green band: the copyright at the start, then Report a bug, the site's own links and the legal links. */
export default function SiteFooter() {
  return (
    <Footer
      className={styles.footer}
      classNames={{ body: styles.inner, start: styles.copy, links: styles.links }}
      collapsible={false}
      start={`© ${new Date().getFullYear()} Hashers Not Trashers • 501(c)(3) Nonprofit`}
    >
      <a href={ORIGINAL_SITE_URL} target="_blank" rel="noopener noreferrer">
        hashersnottrashers.org
      </a>
      <Link to="/work-with-us">Work with us</Link>
    </Footer>
  );
}
